<template>
    <div id='classify'>
        <!-- banner  -->
        <img class="banner" src="../../assets/images/home/banner.png" alt="">

        <div class="type_area classify">
            <!-- 搜索 -->
            <div class="search">
                <input type="text" placeholder="Search" v-model='value'>
                <Icon type="ios-search" @click='search'/>
            </div>

            <!-- title -->
            <div class="title">
                <p v-for='(item,index) in titles' :key='index' @click='cut(item.id)' :class='showcontent==item.id?"active":""' v-loading>{{item.typename}}</p>
            </div>

            <!-- content -->
            <div class="content">
                <div class="product col-xs-6 col-sm-3" v-for="(item,index) in productList" v-if='showcontent==item.typeid' :key='index' @click='skip(item.aid)' v-loading>
                    <img :src='item.litpic' alt="">
                    <!-- <img :src='"http://dalong.test.abontest.com/"+item.litpic' alt=""> -->
                    <p>{{item.title}}</p>
                </div>
            </div>

        </div>
    </div>
</template>



<script>
export default {
    data(){
        return{
            value:'', // 输入内容
            titles:[ // 分类
            ],
            showcontent:0, // 默认显示第一个
            productList:[]
        }
    },

    methods: {
        // 搜索
        search(){
            console.log('搜索的内容',this.value)
            this.$router.push({ path:'/product_search'})
        },


        // 切换
        cut(e){
            this.showcontent=e
        },

        // 查看详情
        skip(e){
            this.$router.push({ path:'/details'+'?id='+e  })
        }
    },
    mounted() {
        var that = this;
        this.$http.get("/api/productClass.php?id="+this.$router.currentRoute.query.id).then((res)=>{
            this.titles = res.data.data;
            res.data.data.forEach((item)=>{
                that.$http.get("/api/product.php?id="+item.id).then((res)=>{
                    res.data.data.forEach((each)=>{
                        that.productList.push(each);
                    })
                })
            });
            this.showcontent = this.titles[0].id;
        });
    }
}
</script>



<style scoped lang="less">
    #classify{
        margin: 3rem 0 0;
        min-height: 45.5rem;
        .banner{
            width:100%;
        }

        // 搜索
        .search{
            margin: 1rem 0;
            input{
                height: 2rem;
                border: 1px solid #ccc;
                outline: none;
                border-radius: 1rem;
                text-indent: 1rem;
            }
            i{
                color:#257CE1;
                font-size: 2rem;
                position: absolute;
                left: 12rem;
                margin-top: 2px;
            }
        }

        // 标题
        .title{
            margin-bottom: 2rem;
            display:flex;
            align-items: center;
            width:100%;
            overflow: auto;
            p{
                margin-right: 2rem;
                color:rgb(105, 103, 103);
            }
            .active{
                color:#257CE1;
                font-weight: bold;
            }
        }
        .title::-webkit-scrollbar {
            display:none;
        }

        // 内容
        .content{
            display:flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding-bottom: 1rem;
            // 单个产品
            .product{
                width:13rem;
                height:16rem;
                box-shadow:3px 3px 5px rgba(168, 168, 166, 0.849);
                margin-bottom: 1rem;
                padding: 0;
                display:flex;
                justify-content: center;
                overflow: hidden;
                img{
                    height:70%;
                }
                p{
                    width:100%;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 1rem;
                    position:absolute;
                    bottom: 1rem;
                }
            }

            .page{
                margin: 0 auto;
            }
        }
    }
</style>
